import React, { useState, useEffect } from 'react';
import { useTranslate } from 'react-polyglot';
import { Button } from '@rmwc/button';
import { TextField } from '@rmwc/textfield';

import Icon from '../icon';
import DropInput from '../dropInput';
import campaignService from '../../services/Campaign';
import ErrorMessage from "../ErrorMessage/ErrorMessage";

import '@material/textfield/dist/mdc.textfield.css';
import '@material/floating-label/dist/mdc.floating-label.css';
import '@material/notched-outline/dist/mdc.notched-outline.css';
import '@material/line-ripple/dist/mdc.line-ripple.css';
import '@material/ripple/dist/mdc.ripple.css';
import '@rmwc/icon/icon.css';
import { DialogActions, DialogButton } from 'rmwc';
import ActionButtons from '../actionsDialog/ActionButtons';

function CloneDemoExp(props) {
    const [name, setName] = useState(props.data.name);

    const [showNotice, setShowNotice] = useState(props.data.showNotice)
    const [campaign, setCampaign] = useState(null);
    const [campaigns, setCampaigns] = useState([]);

    const [campaignId, setCampaignId] = useState(null);
    const [campaignName, setCampaignName] = useState('');


    const [errorState, setErrorState] = useState(false);
    const [message, setMessage] = useState('');
    const [isLoading, setIsLoading] = useState(false)

    const t = useTranslate();

    useEffect(() => {
        fetchCampaings();
    }, [])

    function fetchCampaings() {
        setIsLoading(true)
        campaignService.list(false)
            .then((campaingsResponse) => {

                const campaingsMapped = campaingsResponse.filter(c => c.id !== props.data.campaign.id);
                setCampaigns(campaingsMapped);
                setIsLoading(false)
            });
    }

    return (
    <div className={`coa-dialog-form ${showNotice ? '' : 'clone-demo-experience-container'}`}>
    {
        showNotice ?
        <>
        <p className='coa-dialog-msg-body'>{t(`experiences.cloneDemoExp.msgBody`)}</p>
        <p className='coa-dialog-msg'>{t(`experiences.cloneDemoExp.msg`)}</p>
        <ActionButtons
            cancelText={t('actions.cancel')}
            acceptText={t('actions.accept')}
            onClickCancel={(e) => {e.preventDefault(); props.setOpen(false);}}
            onClickAccept={(e) => {e.preventDefault(); e.stopPropagation(); setShowNotice(false);}}
        ></ActionButtons>
        </>
        :
        <>
        <TextField outlined name="name" label={t('common.labels.nameExperience')} className="fullwidth form-item clone-experience" value={name}
            onChange={e => {
                setName(e.target.value)
        }}/>
        {errorState ? <ErrorMessage message={message}/> : null}
        <div>
            <DropInput
                creatableProps={{
                    menuPortalTarget: document.body,
                    styles: {
                        dropdownIndicator: base => ({...base, color: "#3487F0", paddingRight: '30px'}),
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        control: (base) => ({...base, borderColor: 'rgba(41,41,41,.12)'})
                    },
                    isLoading: isLoading
                }}
                label="Crear un proyecto o agrega la experiencia a un proyecto existente"
                outlined
                className={'new-experience-file-input'}
                icon={<Icon name={'campaings'} className={'new-experience-file-input-icon'}/>}
                onChangeFn={e => {
                    setCampaign(e)
                    setCampaignId(e.id)
                    setCampaignName(e.name)
                    props.onChange({
                        campaign: {
                            id: e.id,
                            name: e.name
                        }
                    });
                }}
                data={campaigns}
                project={campaign}
            />
        </div>
        <ActionButtons
            cancelText={t('actions.cancel')}
            acceptText={t('actions.accept')}
            acceptDisabled={campaign === null}
            onClickCancel={(e) => {
                e.preventDefault();
                props.setOpen(false);
            }}
            onClickAccept={(e) => {
                e.preventDefault();
                if (!name) {
                    setErrorState(true);
                    setMessage('Es necesario agregar un nombre de experiencia')
                } else {
                    props.setOpen(false);
                    setErrorState(false);

                    props.actionHandler({
                        value: {},
                        name: name,
                        key: props.keyData,
                        isDemo: props.data.isDemo,
                        campaign: {
                            id: campaignId,
                            name: campaignName
                        }
                    });
                }
            }}
        ></ActionButtons>
        </>
        }
    </div>)
}

export default CloneDemoExp;